import { GregorioNoteElement } from '../structures/GregorioNoteElement';
import { GregorioScore } from '../structures/GregorioScore';
import { GregorioElement } from '../structures/GregorioSyllable';
import { gabc_det_elements_from_glyphs } from './gabc_det_elements_from_glyphs';
import { gabc_det_glyphs_from_notes } from './gabc_det_glyphs_from_notes';


export function gabc_det_elements_from_notes(
  notes: GregorioNoteElement[],
  score: GregorioScore,
): GregorioElement[] {
  const glyphs = gabc_det_glyphs_from_notes(notes, score);
  const elements = gabc_det_elements_from_glyphs(glyphs);
  return elements;
}
